<template>
  <bar-x-scrollable class="report-toolbar q-pa-sm justify-between">
    <div class="q-mr-md">
      <div class="text-subtitle1">
        {{ report.name }}
        -
        <router-link
          :to="{name: 'client_profile', params: {clientId: report.client.id}}"
          class="q-link"
        >
          {{ $filters.clientName(report.client) }}
        </router-link>
      </div>
    </div>
    <div class="flex justify-end items-center">
      <div class="on-left">
        <strong>Last Saved: </strong>
        <humanize-time :time="report.lastModified" />
      </div>
      <download-btn :report-id="report.id" class="on-left" flat />
    </div>
  </bar-x-scrollable>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Report } from '@/type';
import BarXScrollable from '@/layout/BarXScrollable.vue';
import HumanizeTime from '@/components/HumanizeTime.vue';
import { name as clientNameFilter } from '@/client/client-filter';
import DownloadBtn from './download/DownloadBtn.vue';

export default defineComponent({
  components: {
    BarXScrollable,
    HumanizeTime,
    DownloadBtn,
  },
  props: {
    report: {
      type: Object as () => Report,
      required: true,
    },
  },
  filters: {
    clientName: clientNameFilter,
  },
});
</script>
